import {
  InfiniteProductListParams,
  ProductListQueryParams,
} from '@/types/channel/sooptore/product.schema';

export const PRODUCT_LIST_PREFIX = 'productList';
export const PRODUCT_LIVE_INFO_PREFIX = 'productLiveInfo';

export const PRODUCT_QUERY_KEY = {
  LIVE_INFO: (userId: string) => [PRODUCT_LIVE_INFO_PREFIX, userId] as const,

  LIST: (params: ProductListQueryParams) =>
    [
      PRODUCT_LIST_PREFIX,
      params.userId,
      params.page,
      params.perPage,
      params.orderBy,
    ] as const,

  INFINITE_LIST: (params: InfiniteProductListParams) =>
    [PRODUCT_LIST_PREFIX, params.userId] as const,
} as const;
